import React from "react";

const Span = (props) => {
     if (props.alp === "-") {
          return <span style={{ opacity: "0" }}>{props.alp}</span>;
     } else {
          return <span>{props.alp}</span>;
     }
};
export default Span;
